import React from 'react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/bM36YhbKCuacM69ptUr9Eq/Captura_de_pantalla_2026-09-26_a_la(s)_9.26.54_a._m..png';

// Soft edge mask so the screenshot's own dark background melts into the navy section.
const edgeMask = 'linear-gradient(to right, transparent 0, #000 4%, #000 96%, transparent 100%), linear-gradient(to bottom, transparent 0, #000 4%, #000 96%, transparent 100%)';
export function ProductPack({
  width = 300
}: {
  width?: number;
}) {
  return <img src={MOCKUP_URL} alt="Diesel Diagnostic Pro six-volume box set: modules 1 to 6 with colored spines and the 6-in-1 system cover" className="h-auto max-w-full select-none" style={{
    width,
    WebkitMaskImage: edgeMask,
    maskImage: edgeMask,
    WebkitMaskComposite: 'source-in',
    maskComposite: 'intersect'
  }} draggable={false} data-id="element-5" data-mp="1wkd6vbtcqlnz" />;
}